(() => {
  if (window.cf31BreakCounter) { window.cf31BreakCounter.render(); return; }
  const nodes = () => [...document.querySelectorAll('[data-break-counter]')];
  const extract = title => {
    const matches = String(title).matchAll(/\b(?:break|team\s+(?:random|select)|player\s+select)\s*#?\s*(\d{3,7})\b/gi);
    return Math.max(0, ...[...matches].map(match => Number(match[1])));
  };
  let highest = 0;
  let busy = false;
  let checked = 0;
  const render = () => nodes().forEach(node => {
    highest = Math.max(highest, Number(node.dataset.initial) || 0);
    node.querySelector('[data-break-total]').textContent = highest ? new Intl.NumberFormat('fr-CA').format(highest) : '—';
  });
  async function refresh() {
    render();
    if (busy || !nodes().length || Date.now() - checked < 300000 || document.hidden) return;
    busy = true;
    try {
      const root = window.Shopify?.routes?.root || '/';
      let candidate = 0;
      const seen = new Set();
      for (let page = 1; ; page++) {
        const response = await fetch(`${root}products.json?limit=250&page=${page}`, {headers:{Accept:'application/json'}, cache:'no-store'});
        if (!response.ok) throw new Error('Catalogue indisponible');
        const data = await response.json();
        if (!Array.isArray(data.products)) throw new Error('Catalogue invalide');
        for (const product of data.products) {
          if (seen.has(product.id)) throw new Error('Pagination répétée');
          seen.add(product.id);
          candidate = Math.max(candidate, extract(product.title));
        }
        if (data.products.length < 250) break;
      }
      highest = Math.max(highest, candidate);
      checked = Date.now();
      render();
    } catch (_) {
      // Keep the last verified value; never replace a failed request with zero.
      checked = Date.now();
    } finally { busy = false; }
  }
  window.cf31BreakCounter = {render, refresh, extract};
  refresh();
  setInterval(refresh, 300000);
  document.addEventListener('visibilitychange', refresh);
  document.addEventListener('shopify:section:load', refresh);
})();
